<template>
  <div class="tabs">
    <component v-for="(item, index) in tabs" :is="item.href ? NuxtLink : 'div'" :to="item.href" @click="navigate(index)" class="tabs__item" :class="{ 'tabs__item--selected': index === props.selectedTabIndex, 'cursor-pointer': index <= props.maxEnabledIndex, 'cursor-not-allowed': index > props.maxEnabledIndex }">
      <span v-if="!props.hideIndexes" class="tabs__item__index">{{ (index + 1) }}</span>
      <span class="tabs__item__label">{{ item.text }}</span>
    </component>
  </div>
</template>
<script setup>

import { NuxtLink } from '#components'

const props = defineProps({
  tabs: Array,
  selectedTabIndex: Number,
  maxEnabledIndex: Number,
  hideIndexes: Boolean
});

const emit = defineEmits(['navigate']);

const navigate = (index) => {
  if (index <= props.maxEnabledIndex) {
    emit('navigate', index);
  }
};

</script>
<style lang="postcss">
.tabs {
  @apply flex flex-wrap sm:flex-nowrap flex-1 justify-between gap-1 p-2 mb-20 lg:mb-0 lg:p-0 border-b border-b-secondary;

  &__item {
    @apply block relative uppercase flex-1 mb-1 lg:p-4 sm:w-auto text-lg font-bold text-center opacity-40 transition-opacity;

    &__index {
      @apply lg:mr-2 lg:after:content-['.'] text-3xl text-conversion;
    }

    &__label {
      @apply block absolute top-full w-full mt-8 text-xs lg:inline lg:relative lg:top-0 lg:mt-0 lg:text-lg;
    }

    &--selected {
      @apply font-bold opacity-100;

      &::after {
        @apply content-[''] absolute left-[calc(50%-0.5rem)] w-4 h-4 top-[calc(100%+0.25rem)] lg:left-0 lg:right-0 lg:top-[calc(100%)] lg:w-auto lg:h-2 rounded-full bg-secondary;
      }
    }
  }
}
</style>